import {createAction, createAsyncThunk} from "@reduxjs/toolkit";
import { get } from "../../api";
import { GET_RESERVATION_CONFIG } from "../../api/apiRoutes";
import {FETCH_RESERVATION_CONFIG_SUCCESS, SET_OPEN_FACILITY_SELECT} from "./configTypes";

export const getReservationConfig = createAsyncThunk(FETCH_RESERVATION_CONFIG_SUCCESS, async () => {
  return await get(GET_RESERVATION_CONFIG);
});

export const setOpenFacilitySelect = createAction<boolean>(SET_OPEN_FACILITY_SELECT);
